import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import { ChevronDown } from 'react-feather'
import { BuildingFragment } from '../../generated/graphql'
import { energyPerYearUnit, formatEnergy } from '../../util/formatters'

const useStyles = makeStyles({
  unit: {
    textTransform: 'none',
  },
})

type Column = {
  title: string
  valueGetter: (buildingId: string) => number
}

type Props = {
  title: string
  buildings: BuildingFragment[]
  columns: Column[]
}

export function ResultsByBuildingAccordion({
  title,
  buildings,
  columns,
}: Props): React.ReactElement {
  const classes = useStyles()

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ChevronDown />}>
        <Typography variant="h6">
          {title} <span className={classes.unit}>({energyPerYearUnit})</span>
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              {columns.map((column) => (
                <TableCell key={column.title} align="center">
                  {column.title}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {buildings.map((building) => (
              <TableRow key={building.id}>
                <TableCell>{building.name}</TableCell>
                {columns.map((column) => {
                  const energy = column.valueGetter(building.id)

                  return (
                    <TableCell
                      key={`${building.id}-${column.title}`}
                      align="center"
                    >
                      {energy > 0
                        ? formatEnergy(energy, { omitUnit: true })
                        : '-'}
                    </TableCell>
                  )
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  )
}
